var bridgesWrapper = {
	config: {
		zip: undefined,
		baseApi: 'https://api.usawest.org/bridges/api/v1/ServiceProviders/',
		api: 'https://api.usawest.org/bridges/api/v1/ServiceProviders/',
		constructedUrl: '',
		bridgesResults: {},
		selectedCategories: {},
		icon: '/static_resources/images/global/location-pin.svg',
		resultsContainer: $('.bridgesResults'),
		headerContainer: $('.getHelp-steps'),
		zipInput: $('.bridges-zipInput'),
		firstNameInput: $('.bridges-firstNameInput'),
		defaultIntroText: 'Search here for services in your area. If this is an emergency, call 911.',
		noResultsText: "We're sorry, there are no services in your area. If this is an emergency, call 911."
	},
	initializing: false,
	serializePageCategories: function () {
		$('.getHelp-form:not(.inHeader) .getHelp-categories').on('change', function () {
			if ($(this).val() == '') {
				bridgesWrapper.config.selectedCategories = null;
				if (window.localStorage) {
					localStorage.setItem('selectedCategories', null);
				}
			} else {
				bridgesWrapper.config.selectedCategories = {
					"name": $(this).find(':selected').text(),
					"value": true
				};
				if (window.localStorage) {
					localStorage.setItem('selectedCategories', JSON.stringify(bridgesWrapper.config.selectedCategories.name));
				}
			}
		});
	},
	getJSON: function (url) {
		return $.getJSON(url).then(function (data) {
			return data;
		});
	},
	constructUrl: function () {
		if (bridgesWrapper.config.selectedCategories) {
			bridgesWrapper.config.constructedUrl = bridgesWrapper.config.api + $.param(bridgesWrapper.config.selectedCategories);
			return bridgesWrapper.config.constructedUrl;
		} else {
			return bridgesWrapper.config.api;
		}
	},
	storeResults: function (data) {

		if (!bridgesWrapper.validateData(data)) {
			return;
		}

		if (!window.localStorage) {
			return;
		}

		bridgesWrapper.config.bridgesResults = data;
		localStorage.setItem("bridgesResults" + bridgesWrapper.config.zip, JSON.stringify(data));

		if (window.utag_data !== 'undefined') {
			window.utag_data.getHelp_results = JSON.parse(localStorage.getItem('bridgesResults' + bridgesWrapper.config.zip));
		}

	},
	parseResults: function (data) {

		if (!bridgesWrapper.validateData(data)) {
			return;
		}

		var parsedResults = data;

		if (typeof data === "string" && data != "" && (data.charAt(0) == "{" || data.charAt(0) == "[" || data.charAt(0) == '"')) {
			parsedResults = JSON.parse(data);
		}

		return parsedResults;

	},
	displayResults: function (data) {
		if (typeof data === 'undefined') {
			data = bridgesWrapper.config.bridgesResults;
		}

		bridgesWrapper.config.resultsContainer.empty().append(symphony.templates.getHelpLocation(data));
		$('body').removeClass('loading');

		var d = utag_data || {};
		d.site_section = 'Get Help';
		d.site_type = 'SAL:' + symphonyTerritory;
		d.loc_search_term = JSON.parse(localStorage.getItem('zip')) || "";
		d.loc_search_results = data && data.length > 0 ? data.length.toString() : '0';
		d.login_status = 'Not Logged In';
		d.territory_division = symphonyTerritory;
		d.event_type = 'loc_search';
		symphony.utagView(d);
	},
	validateData: function (data) {
		if (data === null || data === undefined || typeof data == 'undefined') {
			return false;
		}
		return true;
	},
	validZip: function () {
		if (bridgesWrapper.config.zip != undefined && bridgesWrapper.config.zip != null && bridgesWrapper.config.zip !== "") {
			return !isNaN(bridgesWrapper.config.zip);
		} else {
			return false;
		}
	},
	createMap: function (el, width, height) {
		bridgesWrapper.config.bridgesMap = new GMaps({
			el: el,
			lat: thqLatitude,
			lng: thqLongitude,
			zoom: 6,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			//width: width,
			//height: height,
			draggable: true
		});
	},
	updateMap: function () {
		if (!bridgesWrapper.config.bridgesMap) {
			return;
		}
		$('#bridgesMap').show();
		bridgesWrapper.config.bridgesMap.removeMarkers();

		_(bridgesWrapper.config.bridgesResults.serviceProviders).forEach(function (center) {
			bridgesWrapper.config.bridgesMap.addMarker({
				lat: center.lat,
				lng: center.lon,
				title: center.name,
				click: function (e) {
					var icon = this.icon;
					_(bridgesWrapper.config.bridgesMap.markers).forEach(function (marker) {
						marker.setIcon(icon);
					});
					e.setIcon(this.activeIcon);
				},
				icon: {
					size: new google.maps.Size(24, 39),
					url: gdosWrapper.config.icon
				},
				activeIcon: {
					size: new google.maps.Size(24, 39),
					url: '//static.salvationarmy.org/us-east-1/templates/symphony/static_resources/images/global/location-pin-active.svg'
				}
			});
		});

		bridgesWrapper.config.bridgesMap.refresh();
		bridgesWrapper.config.bridgesMap.fitZoom();
		bridgesWrapper.setupMapListeners();
	},
	setupMapListeners: function () {
		$('.bridgesResults-single').on('click', function (e) {
			$('.bridgesResults-single').removeClass('isSelected');
			$(this).addClass('isSelected');
			var id = $(this).data('id');

			var clickedObject = _.find(bridgesWrapper.config.bridgesResults.serviceProviders, function (o) {
				return o.id === id;
			});

			bridgesWrapper.config.bridgesMap.refresh();
			bridgesWrapper.config.bridgesMap.fitZoom();
			bridgesWrapper.config.bridgesMap.setCenter(clickedObject.lat, clickedObject.lon);

		});
	},
	fillName: function (name) {

		if (typeof name == 'undefined') {

			if (window.localStorage && localStorage.getItem('firstName') !== null && localStorage.getItem('firstName') !== "") {
				name = bridgesWrapper.parseResults(localStorage.getItem('firstName'));
			} else if ($('.bridges-firstNameInput').val() !== "") {
				name = $('.bridges-firstNameInput').val();
			} else {
				return;
			}

		}

		if (name !== '') {
			$('.bridges-firstName').empty().text('Hi ' + name + ', ');
			$('.bridges-firstNameInput').empty().val(name);
		} else {
			return;
		}

	},
	fillZip: function (zip) {

		if (typeof zip == 'undefined') {

			if (window.localStorage && localStorage.getItem('zip') !== null && localStorage.getItem('zip') !== "") {
				zip = bridgesWrapper.parseResults(localStorage.getItem('zip'));
			} else if ($('.bridges-zipInput').val() !== "") {
				zip = $('.bridges-zipInput').val();
			} else {
				return;
			}

		}

		if (zip !== '') {
			$('.bridges-zipInput').empty().val(bridgesWrapper.parseResults(localStorage.getItem('zip')));
		} else {
			return;
		}

	},
	fillCategories: function () {
		if (!window.localStorage || localStorage.getItem('selectedCategories') == null) {
			return;
		}

		$('.traffickingText, .domesticViolenceText').removeClass('isShown');

		var category = bridgesWrapper.parseResults(localStorage.getItem('selectedCategories'));

		$('select.getHelp-categories option[name="' + _.camelCase(category) + '"]').attr('selected', 'selected');

		var selectedText = $('select.getHelp-categories option:selected').text();

		$('.bridges-resultsCaption').text('Here are the ' + selectedText + ' services in your area. If this is an emergency, call 911.');

		if ($('select.getHelp-categories option:selected').attr('name') === 'safetyFromDomesticAbuse') {
			$('.domesticViolenceText').addClass('isShown');
		}

		if ($('select.getHelp-categories option:selected').attr('name') === 'safetyFromTrafficking') {
			$('.traffickingText').addClass('isShown');
		}

		bridgesWrapper.config.selectedCategories = category;

	},
	getResults: function (name, zip, categories) {

		bridgesWrapper.fillName(name);
		bridgesWrapper.fillZip(zip);

		bridgesWrapper.getJSON(url).done(function (data) {
			console.log(data);
		});


	},
	submitResults: function (e) {
		e = e || window.event;
		if (typeof e != 'undefined') {
			e.preventDefault();
		}
		bridgesWrapper.config.zip = $('form.getHelp-form').find('.bridges-zipInput').val();
		bridgesWrapper.config.firstName = $('form.getHelp-form').find('.bridges-firstNameInput').val();

		if (!bridgesWrapper.validZip()) {
			return;
		}
		if (bridgesWrapper.config.selectedCategories == null) {
			$('#bridgesMap').hide();
			bridgesWrapper.config.resultsContainer.empty().append("Please select a service category");
			return;
		}

		localStorage.setItem('zip', JSON.stringify(bridgesWrapper.config.zip));
		localStorage.setItem('firstName', JSON.stringify(bridgesWrapper.config.firstName));

		$('body').addClass('loading');
		gdosWrapper.getLatLong(bridgesWrapper.config.zip).done(function (data) {
			if (data != null && data.longitude !== null && data.latitude !== null) {
				gdosWrapper.config.latLong = [data.latitude, data.longitude];
				var url = bridgesWrapper.config.baseApi + gdosWrapper.config.latLong[0] + '/' + gdosWrapper.config.latLong[1];
				bridgesWrapper.config.api = url + '/50?';
				bridgesWrapper.fillCategories();
			} else {
				console.log('error message');
			}
			bridgesWrapper.getJSON(bridgesWrapper.constructUrl()).done(function (data) {
				$('body').removeClass('loading');
				if (data && data.serviceProviders.length > 0) {

					bridgesWrapper.storeResults(data);
					bridgesWrapper.displayResults();
					bridgesWrapper.updateMap();

				} else {
					$('#bridgesMap').hide();
					bridgesWrapper.config.resultsContainer.empty().append(bridgesWrapper.config.noResultsText);
				}
			}).fail(function () {
				$('body').removeClass('loading');
				$('#bridgesMap').hide();
				bridgesWrapper.config.resultsContainer.empty().append(bridgesWrapper.config.noResultsText);
			});
		});


	},
	init: function () {
		var self = this;

		if (!self.initializing) {
			self.initializing = true;

			var tmp = {
				zip: bridgesWrapper.getQueryStringParameterByName('zip'),
				name: bridgesWrapper.getQueryStringParameterByName('name'),
				cats: bridgesWrapper.getQueryStringParameterByName('cats')
			};
			if (tmp.zip + tmp.name + tmp.cats != '') {
				localStorage.setItem('zip', JSON.stringify(tmp.zip));
				localStorage.setItem('firstName', JSON.stringify(tmp.name));
				localStorage.setItem('selectedCategories', JSON.stringify(tmp.cats));
			}

			bridgesWrapper.createMap('#bridgesMap', '600px', '550px');

			bridgesWrapper.fillName();
			bridgesWrapper.fillZip();
			bridgesWrapper.fillCategories();

			bridgesWrapper.config.zip = bridgesWrapper.parseResults(localStorage.getItem('zip')) || undefined;

			bridgesWrapper.serializePageCategories();

			if (bridgesWrapper.config.zip !== undefined) {
				$('body').addClass('loading');
				gdosWrapper.getLatLong(bridgesWrapper.config.zip).done(function (data) {
					if (data != null && data.longitude !== null && data.latitude !== null) {
						gdosWrapper.config.latLong = [data.latitude, data.longitude];
						var url = bridgesWrapper.config.baseApi + gdosWrapper.config.latLong[0] + '/' + gdosWrapper.config.latLong[1];
						bridgesWrapper.config.api = url + '/50?';
					} else {
						console.log('error message');
					}
					bridgesWrapper.getJSON(bridgesWrapper.constructUrl()).done(function (data) {
						$('body').removeClass('loading');
						if (data && data.serviceProviders.length > 0) {

							bridgesWrapper.storeResults(data);
							bridgesWrapper.displayResults();
							bridgesWrapper.updateMap();

						} else {
							$('#bridgesMap').hide();
							bridgesWrapper.config.resultsContainer.empty().append(bridgesWrapper.config.noResultsText);
						}
					}).fail(function () {
						$('body').removeClass('loading');
						$('#bridgesMap').hide();
						bridgesWrapper.config.resultsContainer.empty().append(bridgesWrapper.config.noResultsText);
					});
				});
			}

			$('form.getHelp-form').submit(function (e) {
				bridgesWrapper.submitResults(e)
			});

			bridgesWrapper.config.firstNameInput.on('change', function () {
				if (window.localStorage) {
					localStorage.setItem('firstName', JSON.stringify($(this).val()));
				}
				bridgesWrapper.fillName();
			});

			// bridgesWrapper.config.zipInput.on('keyup', function(){
			// 	return !isNaN(bridgesWrapper.config.zipInput.val()) || bridgesWrapper.config.zipInput.val() == "";
			// });
			bridgesWrapper.config.zipInput.on('change', function () {
				if (window.localStorage) {
					localStorage.setItem('zip', JSON.stringify($(this).val()));
				}
				bridgesWrapper.fillZip();
			});


			if (location.hash === "#results") {
				$('.js-scrollNextSection').trigger('click');
			}

		}
	},

	getQueryStringParameterByName: function (name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	},

};
